import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdiantamentoInserirComponent } from './adiantamento-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: AdiantamentoInserirComponent}
  ])],
  exports: [RouterModule]
})
export class AdiantamentoInserirRoutingModule { }
